// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__W1mGk","importantInfo":"styles_importantInfo__33Euh"};